import { MentorSessionPaymentBookingStatus } from "@edtech-ui/constants/mentor-booking-payment.enum";
import { SessionMeetingStatus } from "@edtech-ui/constants/session-meeting-status.enum";
export const MentorSessionPaymentStatusLabel: Record<MentorSessionPaymentBookingStatus, string> = {
	[MentorSessionPaymentBookingStatus.Pending_Payment]: 'Payment Pending',
	[MentorSessionPaymentBookingStatus.Confirmed]: 'Payment Confirmed',
	[MentorSessionPaymentBookingStatus.Cancelled]: 'Cancelled',
	[MentorSessionPaymentBookingStatus.Expired]: 'Expired',
	[MentorSessionPaymentBookingStatus.Complete]: 'Completed',
	[MentorSessionPaymentBookingStatus.Failed]: 'Failed',
	[MentorSessionPaymentBookingStatus.Refunded]: 'Refunded',
	[MentorSessionPaymentBookingStatus.Pending]: 'Pending',
    [MentorSessionPaymentBookingStatus.Refunded_Processing]: 'Refund Processing',
};

export const MentorSeesionUpComingstatusLabel: Record<SessionMeetingStatus, string> = {
	[SessionMeetingStatus.Waiting]: 'Waiting',
	[SessionMeetingStatus.Accepted]: 'Accepted',
	[SessionMeetingStatus.Complete]: 'Completed',
	[SessionMeetingStatus.Awaiting_Acceptance]: 'Awaiting Acceptance',
	[SessionMeetingStatus.Cancelled]: 'Cancelled',
	[SessionMeetingStatus.Pending_Payment]: 'Payment Pending',
	[SessionMeetingStatus.Cancelled_By_Mentor]: 'Cancelled By Mentor',
	[SessionMeetingStatus.Cancelled_By_Student]: 'Cancelled By Student',
	[SessionMeetingStatus.Refunded_Processing]: 'Refund Processing',
	[SessionMeetingStatus.Refunded]: 'Refund Successful',
	[SessionMeetingStatus.Completed_Session]: 'Completed Session',
    [SessionMeetingStatus.Missed_Session]: 'Missed Session',
};